import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import { withTranslation } from 'react-i18next'
import { getAttributeRequired, getComponentDefinition, getComponentLabel, getTrackingFactLabel } from '../../helper'
import SelectTracked from '../../../FormTracked/SelectTracked'
import { trackingEvent } from '../../../../../constants'
import FactsheetComponentLabel from '../factsheet-component-label'

class AttributeSingleValueSelect extends PureComponent {
  state = {
    required: {
      attribute: false,
      value: false
    },
    valid: true
  }

  componentDidMount () {
    this.updateState()
  }

  componentDidUpdate () {
    this.updateState()
  }

  onChange = (e) => {
    if (e.target.value === '') {
      this.props.deleteAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        this.props.blueprint.id
      )
    } else {
      this.props.putAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        this.props.blueprint.id,
        {
          attributeDefId: this.props.blueprint.id,
          value: e.target.value
        })
    }
  }

  updateState () {
    const factDefId = this.props.parentBlueprint.id
    const fact = this.props.factsheetBlueprint.factTree.facts[factDefId]

    const attributeDefId = this.props.blueprint.id
    const attribute = this.props.factsheetBlueprint.factTree.attributes[attributeDefId]

    const required = getAttributeRequired(this.props.blueprint, attribute, fact)
    let value = ''
    if (typeof this.props.data !== 'undefined') {
      value = this.props.data.value
    }
    let valid = !(!!required.value && value === '')
    if (valid) {
      valid = this.getOptionsMap().hasOwnProperty(value)
    }
    if (
      valid !== this.state.valid
      || required.attribute !== this.state.required.attribute
      || required.value !== this.state.required.value
    ) {
      this.setState(
        {
          valid,
          required
        }
      )
      this.props.putValidationStatus(factDefId, this.props.factInstanceKey, attributeDefId, valid)
    }
  }

  getOptions () {
    return [...this.props.blueprint.options] ?? []
  }

  getOptionsMap () {
    const map = {}
    this.getOptions().forEach((obj) => {
      if (obj.hasOwnProperty('value')) {
        map[obj.value] = obj
      }
    })
    return map
  }

  render () {
    const attributeDefId = this.props.blueprint.id
    const attribute = this.props.factsheetBlueprint.factTree.attributes[attributeDefId]

    let label = getComponentLabel(
      this.props.blueprint,
      attribute
    )

    let value = ''
    if (typeof this.props.data !== 'undefined') {
      value = this.props.data.value
    }

    if (this.props.collapsed) {
      if (value === '') {
        return null
      }
      return <div className={'attribute-single-value-select-collapsed'}>{label}: {value}</div>
    }

    const definition = getComponentDefinition(
      this.props.blueprint,
      attribute
    )

    const options = this.getOptions()
    let placeholder = ''
    if (options[0] && !options[0].hasOwnProperty('value')) {
      const placeholderOption = options.shift()
      if (value === '') {
        placeholder = placeholderOption.label
      }
    }
    return (
      <div className={'attribute-single-value-select'}>
        <div className={'attribute-single-value-select-header'}>
          <FactsheetComponentLabel label={label} definition={definition} required={this.state.required.attribute}/>
        </div>
        <SelectTracked
          eventName={trackingEvent.editValue}
          eventOpts={
            {
              name: getTrackingFactLabel(
                this.props.parentBlueprint, this.props.factsheetBlueprint)
            }
          }
          options={options}
          onChange={this.onChange}
          selected={value}
          valid={this.state.valid}
          placeholder={placeholder}/>
      </div>
    )
  }
}

AttributeSingleValueSelect.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  data: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired
}
export default withTranslation()(AttributeSingleValueSelect)
